module.exports = __webpack_public_path__ + "images/send19f92495c525e9f498cb0957dd8ca900.svg";